var module = angular.module('octopusApp.infrastructure');

module.directive('errorBox', function () {
  return {
    restrict: 'E',
    replace: true,
    transclude: false,
    scope: {
      error: '=',
      onDismiss: '&'
    },
    templateUrl: 'infrastructure/directives/views/error-box.html',
    link: function ($scope, element) {
      $scope.dismiss = dismiss;
      $scope.hasError = false;
      $scope.isOpen = false;

      function dismiss () {
        $scope.isOpen = false;
        $scope.onDismiss();
      }

      $scope.$watch('error', function () {
        $scope.hasError = $scope.error !== null && typeof ($scope.error) !== "undefined";
        $scope.isOpen = true;

        if ($scope.hasError) {
          element.fadeTo(100, 0.5, function () {
            element.fadeTo(100, 1);

            $('html, body').animate({
              scrollTop: element.offset().top + 'px'
            }, 'fast');
          });
        } else {
          element.fadeTo(100, 0);
        }
      });
    }
  };
});



//////////////////
// WEBPACK FOOTER
// ./app/infrastructure/directives/error_box.js
// module id = 6116071778718939
// module chunks = 1